import * as actionTypes from '../constants/actionTypes';
export function showOverlay(hotspotID, scrollPos, meta) {
    return {
        type: actionTypes.SHOW_OVERLAY,
        hotspotID: hotspotID,
        scrollPos: scrollPos,
        meta: meta,
    };
}
// TODO replace the above with this
// showOverlay should never have taken hotspotID in any case
export function showOverlay2(hotspotID, position, scrollPos) {
    return {
        type: actionTypes.SHOW_OVERLAY,
        hotspotID: hotspotID,
        scrollPos: scrollPos,
        position: position,
    };
}
export function hideOverlay(transition, meta) {
    return {
        type: actionTypes.HIDE_OVERLAY,
        transition: transition,
        meta: meta,
    };
}
export function showHoverOverlay(hotspotID, scrollPos, meta) {
    return {
        type: actionTypes.SHOW_HOVER_OVERLAY,
        hotspotID: hotspotID,
        scrollPos: scrollPos,
        meta: meta,
    };
}
export function setOverlayScrollPos(scrollPos, smoothScroll, meta) {
    return {
        type: actionTypes.SET_OVERLAY_SCROLL_POS,
        scrollPos: scrollPos,
        smoothScroll: smoothScroll,
        meta: meta,
    };
}
export function unsetOverlayScrollPos() {
    return {
        type: actionTypes.UNSET_OVERLAY_SCROLL_POS,
    };
}
